<sh-basic-chart [model]="model"></sh-basic-chart>
<sh-widget-loader *ngIf="enableLoading" [hidden]="!isLoading"
                  [addInvertedClass]="addInvertedClassToLoader"
></sh-widget-loader>
